import { SkuFulfillmentMethod } from "../Enums/SkuFulfillmentMethod";

export const FULFILLMENT_METHOD_LABELS = {
  [SkuFulfillmentMethod.REPLENISHABLE]: "Replenishable",
  [SkuFulfillmentMethod.ORDER_ONLY]: "Order Only",
  [SkuFulfillmentMethod.INDIRECT]: "Indirect",
  [SkuFulfillmentMethod.REMOVED]: "Removed",
  [SkuFulfillmentMethod.PLANNING_WINDOW]: "Planning Window",
  [SkuFulfillmentMethod.CAP]: "Cap",
};

export const MOCK_FULFILLMENT_OPTIONS = [
  { id: SkuFulfillmentMethod.REPLENISHABLE, label: "Replenishable" },
  { id: SkuFulfillmentMethod.ORDER_ONLY, label: "Order Only" },
];

function hashSku(sku) {
  const numeric = parseInt(sku, 10);
  if (!isNaN(numeric)) {
    return numeric;
  }
  let hash = 0;
  for (let i = 0; i < sku.length; i++) {
    hash = (hash * 31 + sku.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

function assignMockFulfillmentMethod(item) {
  const sku = item.product?.sku ?? "";
  const hash = hashSku(sku);
  const isOrderOnly = hash % 5 === 0;
  const methodId = isOrderOnly
    ? SkuFulfillmentMethod.ORDER_ONLY
    : SkuFulfillmentMethod.REPLENISHABLE;

  return {
    ...item,
    fulfillmentMethodId: methodId,
    fulfillmentMethodLabel: FULFILLMENT_METHOD_LABELS[methodId],
  };
}

export function injectMockFulfillmentMethod(items) {
  return items.map(assignMockFulfillmentMethod);
}
